import React, { useState } from 'react';

import { UpgradeModal } from '@zapier/upsells';

type UpgradeProps = {
  onUpgrade: () => void;
};

const Upgrade = ({ onUpgrade }: UpgradeProps) => {
  const [isModalOpen, setIsModalOpen] = useState(true);
  const onClose = () => setIsModalOpen(false);

  return isModalOpen ? (
    <UpgradeModal
      onClose={onClose}
      onUpgradeFinish={onUpgrade}
      upgradeReason="email-support"
    />
  ) : null;
};

export default Upgrade;
